import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
interface RunTestS3Response {
  s3_keys: string[];
}

export const runTest = async (id: string): Promise<RunTestS3Response> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<RunTestS3Response>({
    url: `/evaluations/test/run/${orgId}/${id}`,
    target: 'platform',
    method: 'POST',
  });
  return response?.data as RunTestS3Response;
};
